import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvContainer";
/**
 * A simple container component
 */
let LvContainer = class LvContainer extends UIComponent {
};
LvContainer = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvContainer);
export default LvContainer;
//# sourceMappingURL=script.js.map